<template>
  <div class="box-body">
    <div>
      <lte-button
        style="float:right"
        type="btn btn-primary"
        v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('create_case')"
        right_icon="fa fa-plus"
        @click="addNew($event)"
        >{{ $t("invoice.addnew") }}</lte-button
      >
    </div>
    <div>
      <b-table outlined :items="assetTypeItems" :fields="assetTypeFields">
        <template #head()="scope">
          <div class="">{{ $t(scope.label) }}</div>
        </template>
        <template #cell(actions)="row">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-danger dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="fa fa-fw fa-ellipsis-h"></i>
            </button>
            <ul class="dropdown-menu" style="min-width: 50px;">
              <li>
                <button
                  v-if="
                    GET_ACCOUNT_DATA.group_id == 1 || has_perm('update_case')
                  "
                  class="btn btn-primary btn-sm"
                  style="margin-left: 6px;"
                  @click="onShowDetail(row.item)"
                >
                  <i class="glyphicon glyphicon-edit"></i>
                </button>
              </li>
              <li style="margin-top: 5px">
                <button
                  v-if="
                    GET_ACCOUNT_DATA.group_id == 1 || has_perm('delete_case')
                  "
                  class="btn btn-danger btn-sm"
                  style="margin-left: 6px;"
                  @click="onDeleteAssetType(row)"
                >
                  <i class="glyphicon glyphicon-trash"></i>
                </button>
              </li>
            </ul>
          </div>
        </template>
      </b-table>
      <div
        class="box-footer clearfix"
        style="display:contents;"
        v-if="assetTypeItems.length > 0"
      >
        <custom-paginator
          :totalItem="paginateData.totalItem"
          :currentPage="paginateData.currentPage"
          :pageSize="paginateData.pageSize"
          :totalPage="paginateData.totalPage"
          @onpaginate="onCustomPagination"
        />
      </div>
      <!--  -->
    </div>
    <!-- Modal modal-asset-type -->
    <div
      class="modal fade"
      :ref="`modal-asset-type`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  assetTypeData.id === 0
                    ? "assetType.addNew"
                    : "assetType.detail"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="">{{ $t("assetType.assetTypeCode") }}</label>
              <input
                type="text"
                class="form-control"
                v-model="assetTypeData.assetTypeCode"
              />
            </div>
            <div class="form-group">
              <label for="">{{ $t("assetType.title") }}</label>
              <input
                type="text"
                class="form-control"
                v-model="assetTypeData.assetTypeName"
              />
            </div>
            <div class="form-group">
              <label for="">{{ $t("assetType.codeGenerationRules") }}: </label>
              <span>{{ getProjectCode() }}-[ ]-xxxxx</span>
              <input
                type="text"
                class="form-control"
                v-model="assetTypeData.codeGenerationRules"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button type="button" class="btn btn-primary" @click="onSave">
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>
<script>
import CustomPaginator from "@/components/CustomPaginator.vue";
import LTEButton from "@/components/LTEButton.vue";
import LTEModal from "@/components/LTEModal.vue";
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
export default {
  components: {
    "lte-button": LTEButton,
    "lte-modal": LTEModal,
    CustomPaginator
  },
  data: () => ({
    assetTypeFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "assetTypeCode",
        label: "assetType.assetTypeCode"
      },
      {
        key: "assetTypeName",
        label: "assetType.title"
      },
      {
        key: "codeGenerationRules",
        label: "assetType.codeGenerationRules"
      },
      { key: "actions", label: "common.action" }
    ],
    assetTypeItems: [],
    assetTypeData: {
      id: 0,
      assetTypeCode: null,
      assetTypeName: null,
      codeGenerationRules: null
    },
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    isModalVisible: false,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    originalRecordData: []
  }),
  watch: {
    GET_ASSET_TYPE_LIST_DATA: function() {
      let data = this.GET_ASSET_TYPE_LIST_DATA.results;
      let paginate = this.GET_ASSET_TYPE_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.assetTypeItems = [];
      data.forEach((value, i) => {
        let nonumber =
          i +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          id: value.id,
          nonumber: nonumber,
          assetTypeCode: value.code,
          assetTypeName: value.name,
          codeGenerationRules: value.code_generation_rules
        };
        this.assetTypeItems.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_ASSET_TYPE_LIST_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    addNew: function(event) {
      event.preventDefault();
      $(this.$refs[`modal-asset-type`]).modal("show");
      this.assetTypeData = {
        id: 0,
        assetTypeCode: null,
        assetTypeName: null
      };
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-asset-type`]).modal("show");
      this.assetTypeData.id = data.id;
      this.assetTypeData.assetTypeCode = data.assetTypeCode;
      this.assetTypeData.assetTypeName = data.assetTypeName;
      this.assetTypeData.codeGenerationRules = data.codeGenerationRules;
    },
    onDeleteAssetType: function(row) {
      this.originalRecordData = row.item
      this.isModalVisible = true
    },
    getAssetTypeList: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_ASSET_TYPE_LIST(filter);
    },
    getProjectCode: function () {
      return sessionStorage.getItem('projectCode')
    },
    onSave: function() {
      if (utils.isEmptyString(this.assetTypeData.assetTypeCode)) {
        this.ON_SHOW_TOAST({
          message: this.$t("assetType.assetTypeCode"),
          styleType: "danger"
        });
      } else if (utils.isEmptyString(this.assetTypeData.codeGenerationRules)) {
        this.ON_SHOW_TOAST({
          message: this.$t("assetType.codeGenerationRules"),
          styleType: "danger"
        });
      } else {
        let data = {
          id: this.assetTypeData.id,
          name: this.assetTypeData.assetTypeName,
          code: this.assetTypeData.assetTypeCode,
          codeGenerationRules: utils.getCleanStringValue(this.assetTypeData.codeGenerationRules)
        };
        if (this.assetTypeData.id === 0) {
          this.ADD_ASSET_TYPE(data)
            .then(
              function() {
                $(this.$refs[`modal-asset-type`]).modal("hide");
                this.getAssetTypeList(this.paginateData.currentPage);
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.showError(error.response.data.message);
              }.bind(this)
            );
        } else {
          this.UPDATE_ASSET_TYPE(data)
            .then(
              function() {
                $(this.$refs[`modal-asset-type`]).modal("hide");
                this.getAssetTypeList(this.paginateData.currentPage);
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.showError(error.response.data.message);
              }.bind(this)
            );
        }
      }
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getAssetTypeList(data);
    },
    onRefreshData: function() {
      this.getAssetTypeList(1);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_ASSET_TYPE(this.originalRecordData)
        .then(
          function() {
            this.getAssetTypeList(this.paginateData.currentPage);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_ASSET_TYPE_LIST",
      "ADD_ASSET_TYPE",
      "UPDATE_ASSET_TYPE",
      "DELETE_ASSET_TYPE"
    ])
  },
  mounted() {
    this.getAssetTypeList(1);
  }
};
</script>
<style scoped>
/* .modal {
  text-align: center;
}

.modal:before {
  display: inline-block;
  vertical-align: middle;
  content: " ";
  height: 100%;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
} */
</style>



// WEBPACK FOOTER //
// src/views/Property/AssetType.vue